var map = {
	"./Facebook.svg": "9113",
	"./arrow.svg": "2a39",
	"./chevron.svg": "2f6a",
	"./clock.svg": "9d77",
	"./download.svg": "c28f",
	"./email.svg": "7267",
	"./instagram.svg": "9ec4",
	"./people.svg": "88cd",
	"./phone.svg": "ce8e",
	"./plus.svg": "5273",
	"./recurso_signos.svg": "157e",
	"./trash.svg": "d1dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "64ad";